__turbopack_context__.v({
  "first": "gallery-preview-module__KOTigW__first",
  "image": "gallery-preview-module__KOTigW__image",
  "last": "gallery-preview-module__KOTigW__last",
  "more": "gallery-preview-module__KOTigW__more",
  "wrapper": "gallery-preview-module__KOTigW__wrapper",
});
